import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { BLSupplierWiseReport } from './Pages/listing';

export const BLSupplierWiseReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={BLSupplierWiseReport} />
    </Fragment>
)